import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Home } from 'lucide-react';
const services = [{
  icon: <MessageSquare size={24} strokeWidth={1.5} data-id="element-129" />,
  title: 'Безкоштовна консультація',
  description: "Розкажемо, які документи потрібні саме у вашому випадку, скільки це займе часу і чи є підводне каміння. Відповімо на всі питання — без зобов'язань.",
  price: 'Безкоштовно',
  buttonText: 'Записатись на консультацію'
}, {
  icon: <Home size={24} strokeWidth={1.5} data-id="element-130" />,
  title: 'Оформлення прописки у м. Київ',
  description: 'Повний супровід процедури реєстрації місця проживання: від підбору адреси та підготовки документів до отримання штампу у паспорті. Працюємо "під ключ".',
  price: '10 000 грн',
  buttonText: 'Замовити послугу'
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface" data-id="element-131">
      <div className="max-w-7xl mx-auto px-6" data-id="element-132">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-134">Наші послуги</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-135">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-background rounded-3xl border border-border p-8 hover:border-primary/30 transition-colors duration-300 flex flex-col h-full" data-id="element-136">
              <div className="w-14 h-14 bg-surface rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-137">
                {service.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3" data-id="element-138">{service.title}</h3>

              <p className="text-secondary text-sm leading-relaxed mb-8 flex-grow" data-id="element-139">
                {service.description}
              </p>

              <div className="mb-6 pt-5 border-t border-border" data-id="element-140">
                <div className="text-xs text-secondary uppercase tracking-wider mb-1 font-medium" data-id="element-141">
                  Вартість послуги
                </div>
                <div className="text-xl font-semibold text-primary" data-id="element-142">
                  {service.price}
                </div>
              </div>

              <a href="#contact" className="w-full py-3.5 bg-primary text-background rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center justify-center text-sm" data-id="element-143">
                {service.buttonText}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}